(function () {
  'use strict';
  document.querySelectorAll('[data-category-gallery]').forEach(function (gallery) {
    if (gallery.dataset.initialized) return;
    gallery.dataset.initialized = 'true';
    var track = gallery.querySelector('[data-related-track]');
    var section = gallery.closest('[data-related-section]');
    var controls = section.querySelector('.product-related__controls');
    var prev = section.querySelector('[data-related-prev]');
    var next = section.querySelector('[data-related-next]');
    var count = section.querySelector('[data-related-count]');
    var source = JSON.parse(gallery.querySelector('[data-related-product]').textContent);
    var rules = window.YPArtworkCategories;
    var category = rules.resolve(source, new URL(location.href).searchParams.get('recommendation_category'));
    if (category) {
      gallery.dataset.category = category[1];
      gallery.dataset.categoryKey = category[0];
    }
    var smooth = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

    function updateControls() {
      var cards = Array.from(track.children);
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      controls.hidden = maxScroll < 3;
    var edgePadding = parseFloat(getComputedStyle(track).paddingLeft) || 0;
    prev.disabled = track.scrollLeft <= edgePadding + 2;
    next.disabled = track.scrollLeft >= maxScroll - edgePadding - 2;
      if (!cards.length) { count.textContent = ''; return; }
      var viewport = track.getBoundingClientRect();
      var visible = cards.map(function (card, index) {
        var rect = card.getBoundingClientRect();
        return rect.right > viewport.left + 3 && rect.left < viewport.right - 3 ? index : -1;
      }).filter(function (index) { return index >= 0; });
      if (visible.length) count.textContent = (visible[0] + 1) + '–' + (visible[visible.length - 1] + 1) + ' of ' + cards.length;
    }

    function move(direction) {
      track.scrollBy({ left: direction * track.clientWidth, behavior: smooth });
    }
    prev.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      }
      if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        track.scrollTo({ left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: smooth });
      }
    });
    var scrollUpdatePending = false;
    track.addEventListener('scroll', function () {
      if (scrollUpdatePending) return;
      scrollUpdatePending = true;
      requestAnimationFrame(function () { scrollUpdatePending = false; updateControls(); });
    }, { passive: true });
    window.addEventListener('resize', updateControls);

    var pointerId = null, startX = 0, startScroll = 0, dragging = false, suppressClick = false;
    track.addEventListener('dragstart', function (event) { event.preventDefault(); });
    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0 || track.scrollWidth <= track.clientWidth) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = track.scrollLeft;
      dragging = false;
    });
    track.addEventListener('pointermove', function (event) {
      if (event.pointerId !== pointerId) return;
      var distance = event.clientX - startX;
      if (!dragging && Math.abs(distance) > 6) {
        dragging = true;
        track.classList.add('is-dragging');
        track.setPointerCapture(pointerId);
      }
      if (dragging) { event.preventDefault(); track.scrollLeft = startScroll - distance; }
    });
    function finishDrag(event) {
      if (event.pointerId !== pointerId) return;
      pointerId = null;
      track.classList.remove('is-dragging');
      if (!dragging) return;
      dragging = false;
      suppressClick = true;
      var firstCard = track.firstElementChild;
      if (firstCard) {
        var step = firstCard.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
        if (step > 0) track.scrollTo({ left: Math.round(track.scrollLeft / step) * step, behavior: smooth });
      }
      setTimeout(function () { suppressClick = false; }, 250);
    }
    track.addEventListener('pointerup', finishDrag);
    track.addEventListener('pointercancel', finishDrag);
    window.addEventListener('pointerup', finishDrag);
    track.addEventListener('click', function (event) {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressClick = false;
    }, true);

    if (category) {
      track.querySelectorAll('a[href]').forEach(function (link) {
        var url = new URL(link.getAttribute('href'), location.origin);
        if (url.origin !== location.origin || !url.pathname.includes('/products/')) return;
        url.searchParams.set('recommendation_category', category[0]);
        link.setAttribute('href', url.pathname + url.search);
      });
    }
    requestAnimationFrame(updateControls);
  });
})();
